<template>
    <v-dialog v-model="modal" :scrim="false" width="900">
        <v-card>
            <flight-offers :offers="entry.offers">
                <template v-slot:price="{offer}">
                    <tour-offer-delta-button :offer="offer" :offer-key="offerKey" :entry-name="entry.entryName" />
                    <pricing-source-type-label :service="offer" class="text-right full-width" />
                </template>
            </flight-offers>
        </v-card>
    </v-dialog>
</template>

<script lang="ts">
    import {Vue, Component} from 'vue-facing-decorator'
    import {EventBus, SHOW_TOUR_FLIGHT_INFO} from '@/utils/event-bus'
    import FlightOffers from '@/components/flights/search/offers/FlightOffers.vue'
    import TourOfferDeltaButton from '@/components/tours/search/TourOfferDeltaButton.vue'
    import PricingSourceTypeLabel from '@/components/snippets/PricingSourceTypeLabel.vue'

    @Component({
        components: {
            PricingSourceTypeLabel,
            TourOfferDeltaButton,
            FlightOffers,
        },
    })
    export class TourFlightInfoModal extends Vue {
        modal = false
        entry = {}
        offerKey = null

        mounted() {
            EventBus.$on(SHOW_TOUR_FLIGHT_INFO, this.showModal)
        }

        beforeUnmount() {
            EventBus.$off(SHOW_TOUR_FLIGHT_INFO, this.showModal)
        }

        showModal({entry, offerKey}) {
            this.entry = entry
            this.offerKey = offerKey
            this.modal = true
        }
    }

    export default TourFlightInfoModal
</script>
